import { render, staticRenderFns } from "./ProductCardDetails.vue?vue&type=template&id=4bda6baa&"
import script from "./ProductCardDetails.vue?vue&type=script&lang=js&"
export * from "./ProductCardDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/parker/lets_code/frances-valentine/new-fv-original/FV-original/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bda6baa')) {
      api.createRecord('4bda6baa', component.options)
    } else {
      api.reload('4bda6baa', component.options)
    }
    module.hot.accept("./ProductCardDetails.vue?vue&type=template&id=4bda6baa&", function () {
      api.rerender('4bda6baa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/product-card/ProductCardDetails.vue"
export default component.exports